import CallMeLaterModalActiveSHS from '../../../resources/CallMeLaterModalActiveSHS.png';
import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';

const params = {
  shs: {
    bookingModal: {
      buttonBackgroundImage: 'linear-gradient(270deg, #2D4979 0%, #05183A 100%)',
      imageCallMeLaterModalActive: CallMeLaterModalActiveSHS,
    },
    callMeNow: {
      successModal: {
        title: 'Success!',
      },
      failureModal: {
        title: "Oops! An expert isn't availible right now.",
        text: "Please book a time that works for you and we'll call you then.",
      },
    },
    callMeLater: {
      successModal: {
        title: 'Success!',
        subtitle: getPartnerAsset(DynamicAssetsKeys.expertSessionsCallMeLaterSubtitle),
      },
      failureModal: {
        title: 'Oops! We were not able to schedule you for that time.',
        text: 'Please select a new time and book again.',
      },
    },
  },
};

export default params;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/BookingModal/BookingModalsParams.js